import { asyncThunkCreator } from '@reduxjs/toolkit'
import { buildCreateSlice } from '@reduxjs/toolkit/react'

export const createAppSlice = buildCreateSlice({
  creators: {
    asyncThunk: asyncThunkCreator,
  },
})
